"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageManager = void 0;
const default_storage_1 = require("./providers/default-storage");
/**
 * Provides storage mangement integration
 */
class StorageManager {
    /**
     * Get an instance of storage manager
     * @returns
     */
    static getInstance(password, throwErrorIfNotAvailable = true) {
        let storage;
        if (StorageManager._storageConstructor) {
            storage = new StorageManager._storageConstructor(password);
        }
        else {
            storage = new default_storage_1.DefaultStorage(password);
        }
        if (storage && storage.isAvailable()) {
            return storage;
        }
        if (throwErrorIfNotAvailable) {
            throw new Error(`No storage is available, please implement one with IStorage and register with StorageManager.register`);
        }
    }
    /**
     * Provides a custom storage
     * @param storage
     */
    static register(storage) {
        this._storageConstructor = storage;
    }
}
exports.StorageManager = StorageManager;
